<template>
  <div>
      <v-data-table :items="documentos" :headers="colunas"
                    class="az-table-list tabela-documentos elevation-1"
                    :rows-per-page-items="[totalItens]"
                    :options="paginacaoInterna"
                    hide-actions
                    no-data-text="Nenhum documento foi encontrado.">
            <template v-slot:headers="props">
              <tr>
                <th style="padding: 0 !important;">
                  <v-tooltip top>
                  <v-checkbox class="single-checkbox" slot="activator"
                      :input-value="selecionouTodosDocs"
                      :indeterminate="selecionouAlgumDoc && !selecionouTodosDocs"
                      :disabled="documentos.length === 0"
                      hide-details color="light-blue darken-2"
                      @click.stop="selecionarTodosDocs"/>
                    <span v-show="!selecionouTodosDocs">Selecionar todos</span>
                    <span v-show="selecionouTodosDocs">Remover seleção</span>
                  </v-tooltip>
                </th>
                <th v-for="header in props.headers" :key="header.text" :class="header.class" align="left"
                    :style="`${header.style}; ${header.width? 'width: ' + header.width : ''}`">
                  <strong>{{ header.text }}</strong>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
                <tr class="linhas-tabela-docs" style="height: 50px;" :id="props.item.documentoVirtualizadoId">
                  <td style="padding: 0 !important;">
                    <v-checkbox primary hide-details
                                color="light-blue darken-2" class="single-checkbox"
                                :input-value="foiSelecionado(props.item.documentoVirtualizadoId)"
                                @click.stop="selecionarDoc(props.item.documentoVirtualizadoId)"/>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.nome" style="font-size: 14px;">
                      {{props.item.nome}}
                    </span>
                    <span v-show="!props.item.nome" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.tipo" style="font-size: 14px;">
                      {{ props.item.tipo | azEnum(tiposDocumentoVirtualizados) }}
                    </span>
                    <span v-show="!props.item.tipo" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.virtualizacao" style="font-size: 14px;">
                      {{props.item.virtualizacao | azDate('DD/MM/YYYY HH:mm:ss')}}
                    </span>
                    <span v-show="!props.item.virtualizacao" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.origem" style="font-size: 14px;">
                      {{props.item.origem}}
                    </span>
                    <span v-show="!props.item.origem" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.fornecedor" style="font-size: 14px;">
                      {{props.item.fornecedor}}
                    </span>
                    <span v-show="!props.item.fornecedor" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left">
                    <v-tooltip top>
                      <div slot="activator">
                        <v-icon size="20" style="vertical-align: bottom">person</v-icon>
                        <span v-show="props.item" style="font-size: 14px; height: 20px">
                        {{props.item.assinaturas ? props.item.assinaturas.length :'0'}}
                        </span>
                      </div>
                      <span v-if="props.item.assinaturas && props.item.assinaturas.length > 0">
                        <strong class="mr-2" style="color: #1565c0">Assinado por:</strong> <br>
                        <span class="pl-2" v-for="pessoa in props.item.assinaturas" :key="pessoa.nomeSignatario">
                          {{ pessoa.nomeSignatario }} <br>
                        </span>
                      </span>
                      <strong style="color: #1565c0" v-else>
                        Não assinado!
                      </strong>
                    </v-tooltip>
                  </td>
                  <td align="left" style="padding-left: 10px">
                    <span v-show="props.item.situacaoDocumento" style="font-size: 14px;">
                      {{ props.item.situacaoDocumento | azEnum(situacoesDocumentosVirtualizados) }}
                    </span>
                    <span v-show="!props.item.situacaoDocumento" style="font-weight: bold; font-size: 14px;"> -- </span>
                  </td>
                  <td align="left" style="padding: 5px">
                    <span style="display: flex;" class="justify-center">
                      <v-tooltip top>
                        <span slot="activator">
                          <v-icon  size="20" @click="baixar(props.item)">download</v-icon>
                        </span>
                        Baixar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.situacaoDocumento === 'JUNTADO' && !props.item.ehTermoDesentranhamento">
                        <span slot="activator">
                          <v-icon size="20" @click="desentranhar(props.item)">remove_circle</v-icon>
                        </span>
                        Desentranhar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.situacaoDocumento === 'JUNTADO' && !props.item.ehTermoDesentranhamento">
                        <span slot="activator">
                          <v-icon size="20" @click="reordenar(props.item)" class="rotacao-90">sync_alt</v-icon>
                        </span>
                        Reordenar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.situacaoDocumento === 'JUNTADO'">
                        <span slot="activator">
                          <v-icon size="20" @click="cancelar(props.item)">block</v-icon>
                        </span>
                        Cancelar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.situacaoDocumento !== 'JUNTADO' && props.item.situacaoDocumento !== 'CANCELADO' && props.item.uri && !props.item.ehTermoDesentranhamento">
                        <a slot="activator" @click="assinar(props.item)" class="px-1">
                          <icone-assinar-documento/>
                        </a>
                        Assinar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="props.item.situacaoDocumento !== 'JUNTADO' && props.item.situacaoDocumento !== 'CANCELADO' && !props.item.ehTermoDesentranhamento">
                        <a slot="activator" @click="juntar(props.item)" class="px-1">
                          <icone-juntar-documento/>
                        </a>
                        Juntar Documento
                      </v-tooltip>
                      <v-tooltip top v-if="(['REL_ANALISE_SOLICITACAO_CREDENCIAMENTO','TERMO_CREDENCIAMENTO'].includes(props.item.tipo)) && (!props.item.sequencialCP || props.item.sequencialCP === '')">
                        <span slot="activator">
                          <v-icon size="20" @click="enviarPncp(props.item)">send</v-icon>
                        </span>
                        Enviar ao PNCP
                      </v-tooltip>
                      <v-tooltip top v-if="(['REL_ANALISE_SOLICITACAO_CREDENCIAMENTO','TERMO_CREDENCIAMENTO'].includes(props.item.tipo)) && (props.item.sequencialCP && props.item.sequencialCP !== '')">
                        <span slot="activator">
                          <v-icon size="20" @click="removerPncp(props.item)">delete</v-icon>
                        </span>
                        Remover do PNCP
                      </v-tooltip>
                    </span>
                  </td>
                </tr>
            </template>
        </v-data-table>
  </div>
</template>

<script>
import {
  situacoesDocumentosVirtualizados,
  tiposDocumentoVirtualizados
} from '@/commons/constants'
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento.vue";
import IconeJuntarDocumento from "@/commons/components/icones/IconeJuntarDocumento.vue";
import {mapState} from "vuex";
export default {
  name: 'painelDocumentosTabela',
  components: {IconeJuntarDocumento, IconeAssinarDocumento},
  props:{
        documentos: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        totalItens: {
            type: Number,
            required: false,
            default: 0
        },
        paginacaoInterna: {
            type: Object,
            required: false,
            default: () => {
                return {
                    page: 1,
                    itemsPerPage: 10,
                    sortBy: [],
                    sortDesc: [],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false
                }
            }
        },
    },
    data(){
      return {
        situacoesDocumentosVirtualizados,
        tiposDocumentoVirtualizados,
        colunas: [
          {
            text: 'Documento',
            value: 'nome',
            sortable: true,
            class: 'primary--text',
          },
          {
            text: 'Tipo',
            value: 'tipo',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Virtualização',
            value: 'virtualizacao',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Origem',
            value: 'origem',
            sortable: true,
            class: 'primary--text'
          },
          {
            text: 'Fornecedor',
            value: 'fornecedor',
            sortable: true,
            class: 'primary--text',
            width: '150px'
          },
          {
            text: 'Signatários',
            value: 'signatarios',
            sortable: false,
            class: 'primary--text'
          },
          {
            text: 'Situação',
            value: 'situacaoDocumento',
            sortable: true,
            class: 'primary--text',
            width: '100px'
          },
          {
            text: 'Ações',
            sortable: false,
            class: 'primary--text px-1',
            style: 'text-align: center'
          },
        ],
        selecionados: [],
        quantidadeDocumentosSelecionaveis: 5
      }
    },
    computed: {
      ...mapState(['parametros']),
      novasAbasAtivas(){
        return this.parametros.parametro.ativarNovasAbas || false
      },
      selecionouTodosDocs() {
        const quantidadeLotesSelecionados = this.selecionados.length
        return quantidadeLotesSelecionados > 0 && quantidadeLotesSelecionados === this.quantidadeDocumentosSelecionaveis
      },
      selecionouAlgumDoc() {
        return this.selecionados.length > 0
      },
    },
    methods: {
      foiSelecionado(id){
        return this.selecionados.includes(id)
      },
      selecionarDoc(idCheckbox){
        if(this.foiSelecionado(idCheckbox)){
          this.selecionados = this.selecionados.filter(id => id !== idCheckbox)
        }else{
          this.selecionados.push(idCheckbox)
        }
      },
      selecionarTodosDocs(){
        const itens = [...document.getElementsByClassName('linhas-tabela-docs')].map(item => item.id)
        this.$nextTick(() => {
          if (this.selecionouTodosDocs) {
            this.selecionados = []
          } else {
            this.selecionados = itens
          }
        })
      },
      baixar(doc){
        this.$emit('baixar', doc)
      },
      desentranhar(doc){
        this.$emit('desentranhar', doc)
      },
      reordenar(doc){
        this.$emit('reordenar', doc)
      },
      cancelar(doc){
        this.$emit('cancelar', doc)
      },
      assinar(doc){
        this.$emit('assinar', doc)
      },
      juntar(doc){
        this.$emit('juntar', doc)
      },
      enviarPncp(doc){
        this.$emit('enviar-pncp', doc)
      },
      removerPncp(doc){
        this.$emit('remover-pncp', doc)
      }
    },
}
</script>

<style scoped>
.tabela-documentos {
  padding: 16px;
}

.tabela-documentos tr {
  border: 0;
}

.tabela-documentos tr:last-child {
  border-bottom: 0 !important;
}

.tabela-documentos thead tr th {
  padding: 5px 10px !important;
  font-weight: bold;
}

.tabela-documentos thead tr th:first-child {
  padding: 0 24px !important;
}

.tabela-documentos .v-datatable__expand-col {
  border-bottom: 1px solid #ddd;
  padding-top: 0 !important;
}

.single-checkbox .v-input__slot {
  border: 0 !important;
}

.rotacao-90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(80deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

i {
  font-size: 20px;
}

.v-tooltip__content {
  background-color: white !important;
  color: black !important;
}

@keyframes myfirst {
  0% { background-color: white; }
  50% { background-color: #ff7c8a; }
  100% { background-color: white; }
}

@-webkit-keyframes myfirst {
  0% { background-color: white; }
  50% { background-color: #ff7c8a; }
  100% { background-color: white; }
}

.transicionar-destacado {
  -webkit-animation-name: myfirst;
  -webkit-animation-duration: 1s;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-play-state: running;
  animation-name: myfirst;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-play-state: running;
  background-color: white;
}

.linhas-tabela-docs {
  scroll-margin-top: 100px;
}
</style>
